import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import Content from './Content';
import metaOverrideSet from './MetaOverrideSet';

const styles = () => ({
  root: {},
});

/**
 * WizardBadgeStepTemplate used to support rendering a badgeImage attribute image above the title attribute.
 *
 * That logic has moved to WizardStepTemplate and thus WizardBadgeStepTemplate is no more required
 *
 * @deprecated
 */
const WizardBadgeStepTemplate = ({
  className,
  classes,
  resource,
}) => {
  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={Content}
      primaryActionLabel={resource.attr('primaryActionLabel') || undefined}
    />
  );
};

WizardBadgeStepTemplate.defaultProps = {
  className: '',
};

WizardBadgeStepTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default withStyles(styles)(WizardBadgeStepTemplate);
